import { I18n } from '@calendly/i18n'

import { setGetParams } from 'actions/core/navigation'

import { DISCOVER_TAB } from './tab-items'

export const getCategoryTo = (categoryKey) => ({
  pathname: '/integrations',
  search: `?category=${categoryKey}&tab=${DISCOVER_TAB}`
})

// i18n-tasks-use t('publisher.integrations.categories.admin_managed')
// i18n-tasks-use t('publisher.integrations.categories.all')
// i18n-tasks-use t('publisher.integrations.categories.analytics')
// i18n-tasks-use t('publisher.integrations.categories.api_and_connectors')
// i18n-tasks-use t('publisher.integrations.categories.calendars')
// i18n-tasks-use t('publisher.integrations.categories.email_messaging')
// i18n-tasks-use t('publisher.integrations.categories.embed_calendly')
// i18n-tasks-use t('publisher.integrations.categories.extensions_and_apps')
// i18n-tasks-use t('publisher.integrations.categories.integrations')
// i18n-tasks-use t('publisher.integrations.categories.marketing')
// i18n-tasks-use t('publisher.integrations.categories.most_popular')
// i18n-tasks-use t('publisher.integrations.categories.payments')
// i18n-tasks-use t('publisher.integrations.categories.sales_and_crm')
// i18n-tasks-use t('publisher.integrations.categories.security_and_compliance')
// i18n-tasks-use t('publisher.integrations.categories.video_conferencing')
export const getCategoryName = (categoryKey) => (
  I18n.t(`publisher.integrations.categories.${categoryKey}`)
)

// Only these names carry "Workflows" copy that the rebrand renames to "Automations".
const REBRAND_NAME_KEYS = {
  gmail: 'gmail',
  gmail_temp_feature: 'gmail',
  outlook: 'outlook',
}

// i18n-tasks-use t('publisher.workflows_app_shell_rebrand.integrations.names.gmail')
// i18n-tasks-use t('publisher.workflows_app_shell_rebrand.integrations.names.outlook')
export const integrationName = (item, isRebrandEnabled = false) => {
  const key = item.keyOverride || item.key
  const rebrandKey = isRebrandEnabled ? REBRAND_NAME_KEYS[key] : undefined

  if (rebrandKey) {
    return I18n.t(`publisher.workflows_app_shell_rebrand.integrations.names.${rebrandKey}`)
  }

  // i18n-tasks-use t('publisher.integrations.names.#{key}')
  return I18n.t(`publisher.integrations.names.${key}`)
}

export const openIntegrationsTab = (tab) => (dispatch, _) => {
  dispatch(setGetParams({ tab }))
}

export const openCategory = (category) => (dispatch, _) => {
  dispatch(setGetParams({ category }))
}
